import { AbstractControl, FormGroup, ValidationErrors, ValidatorFn } from "@angular/forms";

export const qidValidator = (): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
    const qidNumber = control.value as string;
    if (!qidNumber) {
      return null;
    }
    const qidNumberPattern = /^[0-9]{1,11}$/;
    if (qidNumberPattern.test(qidNumber)) {
      return null;
    } else {
      return { invalidQid: true };
    }
  };

  export const noSpecialCharValidator = ({ allowSpace = true } = {}): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
    const value = control.value as string;
    if (!value) {
      return null;
    }
    const noSpecialPattern = allowSpace ? /^[a-zA-Z\s]*$/ : /^[a-zA-Z0-9]*$/;
    const hasSpecialCharError = !noSpecialPattern.test(value);
    // Check for maximum length of 35 characters
    const hasMaxLengthError = value.length > 35;
    // Return both errors if applicable
    const errors: ValidationErrors = {};
    if (hasSpecialCharError) {
      errors['specialChar'] = true;
    }
    if (hasMaxLengthError) {
      errors['maxLength'] = { requiredLength: 35, actualLength: value.length };
    }
    // Return errors if any exist, otherwise return null
    return Object.keys(errors).length ? errors : null;
  };
  
  export const emailValidator = (): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
    const email = control.value as string;
    if (!email) {
      return null;
    }
    const emailPattern = /^([a-zA-Z0-9_\-\.]+)@([a-zA-Z0-9_\-\.]+)\.([a-zA-Z]{2,5})$/;
    if (emailPattern.test(email)) {
      return null;
    } else {
      return { invalidEmail: true };
    }
  };

  export const onlyNumbersValidator = (): ValidatorFn => (control: AbstractControl): ValidationErrors | null => {
  const value = control.value as string;
  if (!value) {
    return null;
  }
  const onlyNumberPattern = /^-?\d*[.]?\d{0,10}$/;
  if (onlyNumberPattern.test(value)) {
    return null;
  } else {
    return { onlyNumber: true };
  }
};